export const isArchivedReel = (reel) => Boolean(reel && (reel.archived || reel.archivedAt))

export const isPendingUploadedVideo = (reel) => Boolean(
  reel && reel.source === 'upload' && ['queued', 'rendering'].includes(reel.renderStatus)
)

export const hasReelEngagement = (reel) => Boolean(
  reel && (
    reel.publishedAt
    || reel.publicationStatus === 'published'
    || reel.publicationStatus === 'unpublished'
    || (isArchivedReel(reel) && reel.archivePreviousStatus === 'published')
  )
)

export const reelMatchesFilter = (reel, filter) => {
  const archived = isArchivedReel(reel)
  if (filter === 'archived') return archived
  if (archived) return false
  if (filter === 'all') return true
  if (filter === 'failed') return reel.renderStatus === 'failed'
  if (filter === 'rendering') return ['queued', 'rendering'].includes(reel.renderStatus) || reel.publicationStatus === 'uploading'
  return reel.publicationStatus === filter
}
